import { render } from "./SortableTable2.vue?vue&type=template&id=1e9197a1"
import script from "./SortableTable2.vue?vue&type=script&lang=js"
export * from "./SortableTable2.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__